
import Vue from 'vue'
import store from '@/store'
import i18n from '@/plugins/i18n'
import { translateUser } from '@/utils/translator'
import { UserDto } from '@chainsight/networker-backend-axios-sdk'

export default Vue.extend({
	name: 'BusinessMatchSharingProfile',
	data() {
		return {
			overlay: false,
			isAddingFriend: false,
			addFriendSuccess: false,
			sharingUser: {} as UserDto,
		}
	},
	computed: {
		blobBaseUrl() {
			return process.env.VUE_APP_BLOB_API_BASE_URL
		},
		user() {
			return store.state.user
		}
	},
	methods: {
		normalizedWebsite(url: string): string {
			if (!url) return ''
			if (url.startsWith('http://') || url.startsWith('https://')) {
				return url
			}
			return 'https://' + url
		},
		async getSharingUser() {
			this.overlay = true
			try {
				const sharingProfileId = this.$route.params.sharingProfileId
				const response = await this.api$.sharingUserApi.getSharingUser(sharingProfileId)
				if (response.data.data?.user) {
					this.sharingUser = response.data.data.user as UserDto

					// 即時翻譯
					if (i18n.locale === 'zh') {
						await translateUser(this.sharingUser, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateUser(this.sharingUser, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateUser(this.sharingUser, 'ja-JP')
					}
				}
			} catch (error) {
				console.error('Error fetching sharing user:', error)
			}
			this.overlay = false
		},
		async addFriend() {
			if (!this.sharingUser?.id || this.addFriendSuccess) return
			this.isAddingFriend = true
			try {
				await this.api$.userFriendApi.addFriend(this.user.userDto?.id as string, this.sharingUser.id)
				this.addFriendSuccess = true
				setTimeout(() => {
					this.addFriendSuccess = false
				}, 3000)
			} catch (error) {
				console.error('Error adding friend:', error)
			}
			this.isAddingFriend = false
		}
	},
	async created() {
		await this.getSharingUser()
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				if (!this.sharingUser?.id) return
				this.overlay = true
				try {
					// 重新取得原始資料並翻譯
					const sharingProfileId = this.$route.params.sharingProfileId
					const response = await this.api$.sharingUserApi.getSharingUser(sharingProfileId)
					if (response.data.data?.user) {
						this.sharingUser = response.data.data.user as UserDto

						if (i18n.locale === 'zh') {
							await translateUser(this.sharingUser, 'zh-Hant')
						} else if (i18n.locale === 'en') {
							await translateUser(this.sharingUser, 'en-US')
						} else if (i18n.locale === 'ja') {
							await translateUser(this.sharingUser, 'ja-JP')
						}
					}
				} catch (error) {
					console.error('Error re-translating user:', error)
				}
				this.overlay = false
			}
		}
	}
})
